import Image from "next/image";
const Component = () => {
  return (
    <div className="flex  flex-row shadow-2xl">
      <div className="w-full max-w-[10%] xl:max-w-[7vw] py-5 ">
        <Image
          src={"/assets/logo.webp"}
          className="w-full h-auto object-cover"
          width={1200}
          height={1200}
          alt="hero logo"
        />
      </div>
      <div></div>

      <div></div>
    </div>
  );
};

export default Component;
